module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG00226ea9b36f96d8b5f76e19e50a1867.00226ea9.png";